var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawCollaborativeWritingIr40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 799.031,
    height: 618.112,
    viewBox: "0 0 799.031 618.112",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603",
    transform: "translate(-560 -231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8593-478",
    "data-name": "Path 8593",
    d: "M15.18,488.763c0,.872.478,1.573,1.073,1.573h535.1c.6,0,1.073-.7,1.073-1.573s-.478-1.573-1.073-1.573H16.253C15.658,487.191,15.18,487.891,15.18,488.763Z",
    transform: "translate(674.711 358.776)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1582",
    "data-name": "Rectangle 1582",
    width: 19.105,
    height: 3.371,
    transform: "translate(865.162 842.354)",
    fill: "#b6b3c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1583",
    "data-name": "Rectangle 1583",
    width: 19.105,
    height: 3.371,
    transform: "translate(1034.295 842.917)",
    fill: "#b6b3c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8594-479",
    "data-name": "Path 8594",
    d: "M352.955,370.945a27.529,27.529,0,0,1-54.321,0H229.146V521.536h193.3V370.945Z",
    transform: "translate(633.721 321.378)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1584",
    "data-name": "Rectangle 1584",
    width: 193.296,
    height: 5.242,
    transform: "translate(863.43 830.983)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8595-480",
    "data-name": "Path 8595",
    d: "M788.255,487.17H10.776A10.788,10.788,0,0,1,0,476.394V32.688A10.788,10.788,0,0,1,10.776,21.911H788.255a10.789,10.789,0,0,1,10.776,10.776V476.394a10.789,10.789,0,0,1-10.776,10.776Z",
    transform: "translate(560 209.089)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1585",
    "data-name": "Rectangle 1585",
    width: 760.822,
    height: 429.297,
    transform: "translate(578.104 248.056)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8609-481",
    "data-name": "Path 8609",
    d: "M498.59,205.477c-3.443,0-6.242,1.228-6.242,2.734V210.4c0,1.508,2.8,2.734,6.242,2.734H643.424c3.443,0,6.242-1.228,6.242-2.734v-2.187c0-1.508-2.8-2.734-6.242-2.734Z",
    transform: "translate(322.818 221.671)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1586-482",
    "data-name": "Rectangle 1586",
    d: "M8,0H388a8,8,0,0,1,8,8V362a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V8A8,8,0,0,1,8,0Z",
    transform: "translate(762 315)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1587-483",
    "data-name": "Rectangle 1587",
    d: "M8,0H369a8,8,0,0,1,8,8V352a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V8A8,8,0,0,1,8,0Z",
    transform: "translate(772 325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8610-484",
    "data-name": "Path 8610",
    d: "M768.838,309.282c6.2,0,11.237,2.713,11.237,6.045v47.048c0,3.336-5.041,6.045-11.237,6.045H501.644c-6.2,0-11.237-2.713-11.237-6.045V315.331c0-3.336,5.041-6.045,11.237-6.045",
    transform: "translate(324.759 43.556)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8611-485",
    "data-name": "Path 8611",
    d: "M498.59,234.581c-3.443,0-6.242,1.508-6.242,3.361s2.8,3.361,6.242,3.361H720.836c3.443,0,6.242-1.508,6.242-3.361s-2.8-3.361-6.242-3.361Z",
    transform: "translate(322.818 207.451)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8612-486",
    "data-name": "Path 8612",
    d: "M498.59,234.581c-3.443,0-6.242,1.508-6.242,3.361s2.8,3.361,6.242,3.361H720.836c3.443,0,6.242-1.508,6.242-3.361s-2.8-3.361-6.242-3.361Z",
    transform: "translate(322.818 221.402)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8613-487",
    "data-name": "Path 8613",
    d: "M498.59,205.477c-3.443,0-6.242,1.228-6.242,2.734V210.4c0,1.508,2.8,2.734,6.242,2.734H643.424c3.443,0,6.242-1.228,6.242-2.734v-2.187c0-1.508-2.8-2.734-6.242-2.734Z",
    transform: "translate(322.818 272.399)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8614-488",
    "data-name": "Path 8614",
    d: "M498.59,234.581c-3.443,0-6.242,1.508-6.242,3.361s2.8,3.361,6.242,3.361H720.836c3.443,0,6.242-1.508,6.242-3.361s-2.8-3.361-6.242-3.361Z",
    transform: "translate(322.818 258.18)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8615-489",
    "data-name": "Path 8615",
    d: "M498.59,234.581c-3.443,0-6.242,1.508-6.242,3.361s2.8,3.361,6.242,3.361H720.836c3.443,0,6.242-1.508,6.242-3.361s-2.8-3.361-6.242-3.361Z",
    transform: "translate(322.818 272.131)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8616-490",
    "data-name": "Path 8616",
    d: "M498.59,205.477c-3.443,0-6.242,1.228-6.242,2.734V210.4c0,1.508,2.8,2.734,6.242,2.734H643.424c3.443,0,6.242-1.228,6.242-2.734v-2.187c0-1.508-2.8-2.734-6.242-2.734Z",
    transform: "translate(322.818 323.128)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8617-491",
    "data-name": "Path 8617",
    d: "M498.59,234.581c-3.443,0-6.242,1.508-6.242,3.361s2.8,3.361,6.242,3.361H720.836c3.443,0,6.242-1.508,6.242-3.361s-2.8-3.361-6.242-3.361Z",
    transform: "translate(322.818 308.908)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8618-492",
    "data-name": "Path 8618",
    d: "M498.59,234.581c-3.443,0-6.242,1.508-6.242,3.361s2.8,3.361,6.242,3.361H720.836c3.443,0,6.242-1.508,6.242-3.361s-2.8-3.361-6.242-3.361Z",
    transform: "translate(322.818 322.859)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409-493",
    "data-name": "Path 2409",
    d: "M814.221,409.739a1.716,1.716,0,0,1-.242-.018,1.646,1.646,0,0,1-1.088-.649L802.7,395.407a.411.411,0,0,0-.706.083l-5.223,12.219a1.657,1.657,0,0,1-3.127-.242l-10.422-40.34a1.657,1.657,0,0,1,2.459-1.833l35.686,21.5a1.657,1.657,0,0,1-.665,3.064l-13.2,1.53a.411.411,0,0,0-.282.653L817.414,405.7a1.659,1.659,0,0,1-.337,2.319l-1.866,1.391a1.645,1.645,0,0,1-.99.324Z",
    transform: "translate(309.569 34.747)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8619-494",
    "data-name": "Path 8619",
    d: "M8,0H90.284a8,8,0,0,1,8,8V23.921a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z",
    transform: "translate(1118.205 445.393)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409-2-495",
    "data-name": "Path 2409",
    d: "M791.126,409.739a1.716,1.716,0,0,0,.242-.018,1.646,1.646,0,0,0,1.088-.649l10.186-13.664a.411.411,0,0,1,.706.083l5.223,12.219a1.657,1.657,0,0,0,3.127-.242l10.422-40.34a1.657,1.657,0,0,0-2.459-1.833l-35.686,21.5a1.657,1.657,0,0,0,.665,3.064l13.2,1.53a.411.411,0,0,1,.282.653L787.932,405.7a1.659,1.659,0,0,0,.337,2.319l1.866,1.391a1.645,1.645,0,0,0,.99.324Z",
    transform: "translate(23.863 112.82)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8620-496",
    "data-name": "Path 8620",
    d: "M90.284,0H8A8,8,0,0,0,0,8V23.921a8,8,0,0,0,8,8H90.284a8,8,0,0,0,8-8V8A8,8,0,0,0,90.284,0Z",
    transform: "translate(722.289 523.466)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1289",
    "data-name": "Ellipse 1289",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(1256 281)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1290",
    "data-name": "Ellipse 1290",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(1236 281)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1291",
    "data-name": "Ellipse 1291",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(1216 281)",
    fill: "#6c63ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawCollaborativeWritingIr40);
export default __webpack_public_path__ + "static/media/undraw_collaborative-writing_ir40.ce5f2196a1f1016f9508adb9696c6127.svg";
export { ForwardRef as ReactComponent };